import React, { Component } from 'react';
import './ContactMe.css';

export default class ContactMe extends Component {
  render() {
    return (
      <section id="contact-me" className="contact">
        <form action="https://formspree.io/nick@piinecone.com" method="POST">
          <div className="container">
            <h2>Contact</h2>
            <div className="field">
              <label>Email</label>
              <input
                type="email"
                placeholder="nick@eggslist.com"
                name="email"
                id="email"
              />
            </div>
            <div className="field">
              <label>Message</label>
              <textarea
                placeholder="Local yokels scramble to launch eggslist."
                name="message"
                rows={5}
              />
            </div>
            <div className="field">
              <button type="submit">Send</button>
            </div>
          </div>
        </form>
        <a target="_blank" rel="noopener noreferrer" className="footer-attribution" href="https://www.svgbackgrounds.com/set/free-svg-backgrounds-and-patterns/">Free SVG Backgrounds and Patterns by SVGBackgrounds.com</a>
      </section>
    );
  }
}
